import React from 'react';
import * as yup from "yup";
import {
    CostSupplier,
    CostSupplierQueryQuery,
    useCostSupplierQueryQuery, useCostSuppliersMutationMutation
} from '../../generated/graphql';

import {ListEditor} from '../../components/list-editor';
import {CostSupplierCategorySelect} from "../../components/MaterialSelects/CostSupplierCategorySelect";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const schema =  yup.array().of(
        yup.object().shape({
            'label': yup.string().required(),
            'code':yup.string().required(),
            'costSupplierCategory': yup.object().required()
        }));

function blankCostSupplier(): CostSupplier {
    return {
        id: uniqueId(),
        code: '',
        label: '',
        costSupplierCategory: null
    };
}

const columns = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
}, {
    header: 'Code',
    accessor: 'code',
    dataType:'text',
    width:'narrow'
}, {
    header: 'Category',
    accessor: 'costSupplierCategory',
    dataType:'select',
    options: {
        label:'label',
        renderEditor: ({ field }) => <CostSupplierCategorySelect {...field} autoFocus={true} />
    }
}
];

function getValues(data:CostSupplierQueryQuery) {
    return data?.costSuppliers?.data;
}


const relationships = {
    'costSupplierCategory':'connect'
};

const CostSuppliers = () => {
    const url = useLocation().pathname;
    const query = useCostSupplierQueryQuery();
    const [mutation,mutationResult] = useCostSuppliersMutationMutation();
    return (
        <ListEditor
            className="cost-suppliers"
            columns={columns}
            validationSchema={schema}
            title="Cost Suppliers"
            permission="costsuppliers"
            relationships={relationships}
            mutation={mutation}
            saveResult={mutationResult}
            query={query}
            newRow={blankCostSupplier}
            newRowLabel="Add Cost Supplier"
         baseUrl={url} getValues={getValues}
        />);
}
export default CostSuppliers;